<template>
    <section aria-hidden="false" aria-labelledby="steps-uid-6-h-0" class="body current" id="steps-uid-6-p-0" role="tabpanel">
        <form @submit.prevent="validate">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Currency</label>
                        <div :class="{'is-invalid': submitted && errors.has('currency')}" class="form-control p-0-0">
                            <currency-select
                                    @currency-select="setCurrency"
                                    data-vv-as="currency"
                                    name="currency"
                                    ref="currency"
                                    v-model="pricing.currency"
                                    v-validate="'required'">
                            </currency-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Units</label>
                        <div :class="{'is-invalid': submitted && errors.has('unit')}" class="form-control p-0-0">
                            <unit-select
                                    @unit-select="setUnit"
                                    data-vv-as="unit"
                                    name="unit"
                                    ref="unit"
                                    v-model="pricing.unit"
                                    v-validate="'required'">
                            </unit-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Pricing Type</label>
                        <div class="col-md-4 form-check">
                            <input :class="{'is-invalid': submitted && errors.has('cash')}"
                                   class="form-check-input"
                                   data-vv-as="pricing-type"
                                   id="cash"
                                   name="cash"
                                   type="radio"
                                   v-model="pricing.type"
                                   v-validate="'required'"
                                   value="CASH">
                            <label class="form-check-label" for="cash">Cash</label>
                        </div>
                        <div class=" col-md-4 form-check">
                            <input :class="{'is-invalid': submitted && errors.has('basis')}"
                                   class="form-check-input"
                                   data-vv-as="pricing-type"
                                   id="basis"
                                   name="basis"
                                   type="radio"
                                   v-model="pricing.type"
                                   v-validate="'required'"
                                   value="BASIS">
                            <label class="form-check-label" for="basis">Basis</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Quantity</label>
                        <div class="input-group">
                            <input :class="{'is-invalid': submitted && errors.has('quantity')}"
                                   class="form-control"
                                   data-vv-as="pricing-quantity"
                                   name="quantity"
                                   type="text"
                                   v-model="pricing.quantity"
                                   v-validate="'required'">
                            <div :class="{'is-invalid': submitted && errors.has('quantity')}" class="input-group-append">
                                <span class="input-group-text" v-if="pricing.unit">{{pricing.unit.symbol}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Price</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" v-if="pricing.currency">{{pricing.currency.symbol}}</span>
                            </div>
                            <input :class="{'is-invalid': submitted && errors.has('price')}"
                                   class="form-control"
                                   data-vv-as="pricing-price"
                                   name="price"
                                   type="text"
                                   v-model="pricing.price"
                                   v-validate="'required'">
                            <div class="input-group-append">
                                <span class="input-group-text" v-if="pricing.unit">/{{pricing.unit.symbol}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="estimated">Estimated Deal Value</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" v-if="pricing.currency">{{pricing.currency.symbol}}</span>
                            </div>
                            <input class="form-control" id="estimated" name="estimated" readonly type="number" v-model="estimated">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
    import {mapGetters} from "vuex";
    import CurrencySelect from "../../../common/CurrencySelect";
    import Multiselect from "vue-multiselect";
    import UnitSelect from "../../../common/UnitSelect";
    import Bignumber from "bignumber.js";

    export default {
        name: "AllOffers",
        components: {Multiselect, CurrencySelect, UnitSelect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"]),

            estimated() {
                return new Bignumber(this.pricing.price)
                .multipliedBy(new Bignumber(this.pricing.quantity))
                .toNumber()
            }
        },
        data() {
            return {
                submitted: false,
                currencies: [],
                pricing: this.$parent.pricing,
                priceUnit: this.$parent.priceUnit
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            });
        },
        methods: {
            async init() {
                if(this.pricing.unit) {
                    this.$refs.unit.unit         = this.pricing.unit;
                }
                if(this.pricing.currency) {
                    this.$refs.currency.currency = this.pricing.currency;
                }
            },
            setCurrency(e) {
                // this.pricing.currency_id = e.id;
                this.pricing.currency = e;
            },
            setUnit(e) {
                this.pricing.unit = e;
            },
            async validate() {
                this.submitted = true;
                return await this.$validator.validate();
            }
        }
    }
</script>

<style scoped>
    .invalid-feedback {
        display: block;
    }
</style>
